(function() {
    'use strict';

    angular
        .module('functional7App')
        .controller('MaterialDeleteController',MaterialDeleteController);

    MaterialDeleteController.$inject = ['$uibModalInstance', 'entity', 'Material'];

    function MaterialDeleteController($uibModalInstance, entity, Material) {
        var vm = this;

        vm.material = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Material.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
